// Fossil Depot — PDP 1:1 (interacciones)
// Galeria de miniaturas, acordeones, sticky bar y actualizacion de precio por variante.
// El "Agregar al carrito" usa el form nativo de Shopify (no se toca aqui).

(() => {
  const root = document.querySelector('[data-fossil-pdp]');
  if (!root) return;

  // ── Galeria: miniatura -> imagen principal ──
  const main = root.querySelector('[data-fossil-main]');
  root.querySelectorAll('[data-fossil-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const full = thumb.dataset.full;
      if (main && full) main.src = full;
      root.querySelectorAll('[data-fossil-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ── Acordeones ──
  root.querySelectorAll('[data-fossil-acc-header]').forEach((header) => {
    header.addEventListener('click', () => {
      const acc = header.closest('[data-fossil-accordion]');
      const body = acc && acc.querySelector('.m-accordion-body');
      const inner = body && body.querySelector('.m-accordion-body-inner');
      if (!acc || !body || !inner) return;
      if (acc.classList.contains('open')) {
        acc.classList.remove('open');
        body.style.maxHeight = '0';
      } else {
        acc.classList.add('open');
        body.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  // ── Precio segun variante ──
  const variant = root.querySelector('[data-fossil-variant]');
  if (variant) {
    variant.addEventListener('change', () => {
      const opt = variant.options[variant.selectedIndex];
      const price = opt && opt.dataset.price;
      if (price) {
        root.querySelectorAll('[data-fossil-price], .m-sticky-price').forEach((el) => {
          el.textContent = price;
        });
      }
    });
  }

  // ── Sticky bar: aparece al pasar el area de compra ──
  const sticky = root.querySelector('[data-fossil-sticky]');
  const anchor = root.querySelector('.m-pdp-atc') || root.querySelector('.m-pdp-info');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          sticky.classList.add('is-visible');
        } else {
          sticky.classList.remove('is-visible');
        }
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  // ── Cross-sell con agregado rapido (estilo CMX) ──
  const xs = root.querySelector('[data-pdp-xsell]');
  if (xs) {
    const pid = xs.dataset.productId;
    const track = xs.querySelector('[data-pdp-xsell-track]');
    const money = (c) => {
      const a = (c / 100).toFixed(2).split('.');
      a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + a.join('.');
    };
    const esc = (s) => {
      const d = document.createElement('div');
      d.appendChild(document.createTextNode(s || ''));
      return d.innerHTML;
    };

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', {
      credentials: 'same-origin',
    })
      .then((r) => r.json())
      .then((data) => {
        const prods = (data.products || []).filter((p) => p.available).slice(0, 8);
        if (!prods.length || !track) return;
        track.innerHTML = prods
          .map((p) => {
            const img = p.featured_image
              ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_300x300$1$2')
              : '';
            const vid = p.variants && p.variants[0] ? p.variants[0].id : '';
            return (
              '<div class="m-pdp-xsell__card">' +
              '<a class="m-pdp-xsell__link" href="' + p.url + '">' +
              (img
                ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="300">'
                : '') +
              '<span class="m-pdp-xsell__name">' + esc(p.title) + '</span>' +
              '<span class="m-pdp-xsell__price">' + money(p.price) + '</span>' +
              '</a>' +
              '<button type="button" class="m-pdp-xsell__add" data-xs-add data-vid="' + vid + '">Agregar</button>' +
              '</div>'
            );
          })
          .join('');
        xs.hidden = false;
      })
      .catch(() => {});

    if (track) {
      track.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-xs-add]');
        if (!btn || !btn.dataset.vid) return;
        btn.disabled = true;
        const label = btn.textContent;
        // El interceptor del mini-cart CMX detecta /cart/add y abre el carrito.
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: parseInt(btn.dataset.vid, 10), quantity: 1 }),
        })
          .then((r) => r.json())
          .then(() => {
            btn.textContent = '✓';
            setTimeout(() => {
              btn.textContent = label;
              btn.disabled = false;
            }, 1500);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(() => {
            btn.disabled = false;
          });
      });
    }
  }
})();
